module.exports = __webpack_public_path__ + "static/media/arrow-dropdown.14a8bfd2.svg";